module.exports = __webpack_public_path__ + "media/images/sandbox/envelope_opt-322774a0e6b1f5093f2ecee5d14a8998.png";